export default __webpack_public_path__ + "static/media/purple.e045c35c.svg";